import React from 'react';
import { motion } from 'framer-motion';
import { MetricCardProps } from '../types';
import { cn } from '../../../../lib/utils';
import { getThemeClass } from '../../../../lib/theme';
import { metricVariants, withReducedMotion, viewportOptions } from '../../../../lib/animations/variants';

const sizeStyles = {
  sm: {
    value: 'text-3xl',
    unit: 'text-lg',
    label: 'text-lg',
    description: 'text-sm',
    container: 'p-6'
  },
  md: {
    value: 'text-4xl',
    unit: 'text-xl',
    label: 'text-xl',
    description: 'text-base',
    container: 'p-8'
  },
  lg: {
    value: 'text-5xl',
    unit: 'text-2xl',
    label: 'text-2xl',
    description: 'text-lg',
    container: 'p-10'
  }
};

export const MetricCard: React.FC<MetricCardProps> = ({
  value,
  unit,
  label,
  description,
  variant = 'light',
  size = 'md',
  accent = 'primary',
  className
}) => {
  const dimensions = sizeStyles[size];

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={viewportOptions}
      variants={withReducedMotion(metricVariants)}
    >
      <div className={cn(
        'rounded-lg transition-shadow duration-300',
        dimensions.container,
        getThemeClass(`colors.${accent}.surface`),
        'hover:shadow-md',
        className
      )}>
        <div className="space-y-2">
          <div className="flex items-baseline">
            <span className={cn(
              dimensions.value, 
              getThemeClass(`colors.${accent}.text`)
            )}>
              {value}
            </span>
            {unit && (
              <span className={cn(
                'ml-1',
                dimensions.unit,
                getThemeClass(`colors.${accent}.text`)
              )}>
                {unit}
              </span>
            )}
          </div>
          <div>
            <h3 className={cn(
              dimensions.label,
              getThemeClass(`colors.${accent}.text`),
              'font-medium'
            )}>
              {label}
            </h3>
            {description && (
              <p className={cn(
                dimensions.description,
                getThemeClass(`colors.${accent}.text`),
                'opacity-80'
              )}>
                {description}
              </p>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
};